enum ReviewStepsFilterOptionsEnum {
	TO_REVIEW = 'toReview',
	REVIEWED = 'reviewed',
	REVIEWED_AND_SUBMITTED = 'reviewedAndSubmitted'
}

export { ReviewStepsFilterOptionsEnum };
